module.exports = ".main-title {\n  text-align: center;\n  margin-bottom: 50px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dashboard.component.scss
// module id = ./src/app/modules/dashboard/dashboard.component.scss
// module chunks = main